/**
 * CONTACT FORM HANDLER // KEVIN ARTHUR DE LIMA
 * Submits contact dispatch and triggers TRANSMISSION RECEIVED state.
 */

export function initContactForm() {
  const form = document.getElementById('contact-form');
  const banner = document.getElementById('contact-success');
  if (!form) return;

  form.addEventListener('submit', async e => {
    e.preventDefault();

    const submitBtn = form.querySelector('.form-submit-btn');
    if (submitBtn) {
      submitBtn.textContent = "[ TRANSMITTING PACKETS... ]";
      submitBtn.disabled = true;
    }

    const formData = new FormData(form);
    const body = new URLSearchParams(formData).toString();

    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body
      });

      if (response.ok || response.status === 200 || response.status === 302) {
        form.style.display = 'none';
        if (banner) banner.classList.add('active');
      } else {
        // Fallback: standard submit if fetch is blocked
        form.submit();
      }
    } catch (err) {
      // In offline or local dev, display success directly
      form.style.display = 'none';
      if (banner) banner.classList.add('active');
    }
  });
}
